import React from 'react';
import { Helmet } from 'react-helmet-async';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { VideoPlayer } from '../../../VideoPlayer/LoadableVideoPlayer';
import DeviationMediaService from '../../../utils/DeviationMediaService';
import { getSource } from '../../_helpers';
import s from './Film.scss';
export const FilmFullView = ({ deviation, height, width })=>{
    const videoFile = getSource(DeviationMediaService.getMediaByType(deviation, 'video'));
    if (!videoFile) {
        return null;
    }
    const previewFile = DeviationMediaService.getDeviationFile(deviation, 'preview');
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "FillFullView"
    }, /*#__PURE__*/ React.createElement(Helmet, null, previewFile && /*#__PURE__*/ React.createElement("link", {
        rel: "preload",
        href: previewFile.src,
        as: "image"
    }), /*#__PURE__*/ React.createElement("link", {
        rel: "preload",
        href: videoFile.src,
        as: "video"
    })), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: s['root'],
        style: {
            width,
            height
        }
    }, /*#__PURE__*/ React.createElement(VideoPlayer, {
        width: width,
        height: height,
        src: videoFile.src,
        loadingCover: previewFile && previewFile.src,
        autoPlay: false
    }))));
};
FilmFullView.displayName = 'FilmFullView';
export default FilmFullView;

//# sourceMappingURL=Film.js.map